import React from 'react'

const Thankyou = () => {
  return (
    <div className='text-center text-[6rem] font-serif '>Thanks for Shopping</div>
  )
}

export default Thankyou